import React, { ChangeEvent, useEffect, useState } from 'react';
import { Breadcrumbs, Input } from '@cokitchen/cokitchen-components';
import PageHeaderText from 'components/base/page-header-text';
import { ROUTE_KEYS } from 'utils/constants';
import { ReactComponent as CalendarIcon } from 'assets/icons/calendar-icon.svg';
import { ReactComponent as TimeIcon } from 'assets/icons/time-icon.svg';
import './styles.scss';
import useCreatePostContext from 'contexts/create-post.context';
import moment from 'moment';
import DatePicker from 'components/base/date-picker';
import TimeSelector from 'components/base/time-selector';

const CreatePostTimeline = () => {
  const { setCreatePostForm, createPostForm, setDisabled, image } = useCreatePostContext();
  const [showStartDateModal, setShowStartDateModal] = useState(false);
  const [showEndDateModal, setShowEndDateModal] = useState(false);
  const [noExpirationDate, setNoExpirationDate] = useState(!createPostForm.end_date);

  const breadcrumbs = [
    { name: 'Manage homepage', path: ROUTE_KEYS.HOME },
    { name: 'New post', path: ROUTE_KEYS.CREATE_POST }
  ];

  useEffect(() => {
    if (
      !createPostForm.heading ||
      !createPostForm.title ||
      !createPostForm.body ||
      !image ||
      !createPostForm.cokitchen_ids.length ||
      !createPostForm.start_date ||
      (!noExpirationDate && !createPostForm.end_date)
    ) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [createPostForm]);

  const handleNoExpiryDateChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      setCreatePostForm({
        ...createPostForm,
        end_date: undefined,
        end_time: null
      });
    }
    setNoExpirationDate(e.target.checked);
  };
  return (
    <div className='mx-10 pt-8 max-w-[700px]'>
      {showStartDateModal && (
        <DatePicker
          isOpen={showStartDateModal}
          onClose={() => setShowStartDateModal(false)}
          title='Select Start Date'
          handleDateSelect={(value) =>
            setCreatePostForm({ ...createPostForm, start_date: value, end_date: undefined })
          }
          minDate={new Date()}
        />
      )}
      {showEndDateModal && (
        <DatePicker
          isOpen={showEndDateModal}
          onClose={() => setShowEndDateModal(false)}
          title='Select Expiry Date'
          handleDateSelect={(value) => setCreatePostForm({ ...createPostForm, end_date: value })}
          minDate={createPostForm.start_date || new Date()}
        />
      )}
      <Breadcrumbs breadcrumbs={breadcrumbs} />
      <div className='mt-8'>
        <PageHeaderText title='Create Post' description='Create a new post lorem dolum ipsum' />
      </div>
      <div className='flex items-start w-full gap-4 mb-6'>
        <section className='flex flex-col gap-1.5 grow'>
          <p className='text-gray-6 text-sm'>Start date</p>
          <div
            className='border border-gray-19 rounded-md flex items-center  py-4 px-5 cursor-pointer h-[50px]'
            onClick={() => setShowStartDateModal(true)}>
            <CalendarIcon className='mr-2' />
            <p className='text-sm text-gray-6'>
              {createPostForm.start_date
                ? moment(createPostForm.start_date).format('YYYY-MM-DD')
                : 'YYYY-MM-DD'}
            </p>
          </div>
        </section>
        <section className='flex flex-col gap-1.5 grow'>
          <p className='text-gray-6 text-sm'>Start time</p>
          <div className='border border-gray-19 rounded-md flex items-center py-4 px-5 h-[50px]'>
            <TimeIcon className='mr-2' />
            <TimeSelector
              value={createPostForm.start_time}
              onChange={(value) => setCreatePostForm({ ...createPostForm, start_time: value })}
            />
          </div>
        </section>
      </div>
      {!noExpirationDate && (
        <div className='flex items-start w-full gap-4'>
          <section className='flex flex-col gap-1.5 grow'>
            <p className='text-gray-6 text-sm'>Expiry date</p>
            <div
              className='border border-gray-19 rounded-md flex items-center  py-4 px-5 cursor-pointer h-[50px]'
              onClick={() => setShowEndDateModal(true)}>
              <CalendarIcon className='mr-2' />
              <p className='text-sm text-gray-6'>
                {createPostForm.end_date
                  ? moment(createPostForm.end_date).format('YYYY-MM-DD')
                  : 'YYYY-MM-DD'}
              </p>
            </div>
          </section>
          <section className='flex flex-col gap-1.5 grow'>
            <p className='text-gray-6 text-sm'>Stop time</p>
            <div className='border border-gray-19 rounded-md flex items-center py-4 px-5 h-[50px]'>
              <TimeIcon className='mr-2' />
              <TimeSelector
                value={createPostForm.end_time}
                onChange={(value) => setCreatePostForm({ ...createPostForm, end_time: value })}
              />
            </div>
          </section>
        </div>
      )}
      <div className='flex items-center gap-2 mt-6'>
        <Input
          type='checkbox'
          checked={noExpirationDate}
          onChange={(e) => {
            handleNoExpiryDateChange(e);
          }}
        />
        <p className='font-medium'>No expiration date</p>
      </div>
    </div>
  );
};

export default CreatePostTimeline;
